import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-67599d4a")

_pushScopeId("data-v-67599d4a")
const _hoisted_1 = {
  id: "heroPlane",
  class: "flex flex--v flex--width"
}
const _hoisted_2 = { class: "hero-carousel" }
const _hoisted_3 = { class: "carousel-space-buttons flex" }
const _hoisted_4 = { class: "hero-content flex flex--width flex--height flex--h flex--halign-sb flex--valign-e disable-pointer-events" }
const _hoisted_5 = { class: "hero-plane-content hero-plane-content--left flex--extend flex flex--v flex--valign-s flex--gap-20 disable-pointer-events" }
const _hoisted_6 = { class: "flex flex--v disable-pointer-events" }
const _hoisted_7 = { class: "text text--size-48 text--semi-bold text--color-white text--shadow-big" }
const _hoisted_8 = { class: "text more-negative-margin text--size-56 text--extra-bold text--color-white text--shadow-big" }
const _hoisted_9 = { class: "flex flex--v disable-pointer-events" }
const _hoisted_10 = { class: "text text--size-18 text--height-26 text--regular text--color-white text--shadow-big" }
const _hoisted_11 = { class: "text text--size-18 text--height-26 text--regular text--color-white text--shadow-big" }
const _hoisted_12 = { class: "hero-plane-content hero-plane-content--right flex--extend flex flex--v flex--valign-e flex--gap-20 disable-pointer-events" }
const _hoisted_13 = { class: "flex flex--v disable-pointer-events" }
const _hoisted_14 = { class: "text text--size-48 text--semi-bold text--color-white text--shadow-big text--right" }
const _hoisted_15 = { class: "more-negative-margin text text--size-56 text--extra-bold text--color-white text--shadow-big text--right" }
const _hoisted_16 = { class: "flex flex--v disable-pointer-events" }
const _hoisted_17 = { class: "text text--size-18 text--height-26 text--regular text--color-white text--shadow-big text--right" }
const _hoisted_18 = { class: "text text--size-18 text--height-26 text--regular text--color-white text--shadow-big text--right" }
const _hoisted_19 = { class: "flex flex--valign-c flex--halign-c flex--wrap flex--gap-10" }
const _hoisted_20 = {
  key: 0,
  class: "text text--size-16 text--primary-b text--less-gap"
}
const _hoisted_21 = { class: "text text--size-16 text--medium text--primary-b text--less-gap" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_GenericButton = _resolveComponent("GenericButton")
  const _component_CarouselDots = _resolveComponent("CarouselDots")
  const _component_Plane = _resolveComponent("Plane")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Plane, {
      class: "hero-plane flex--halign-e disable-pointer-events",
      rounded: true,
      darker: true
    }, {
      background: _withId(() => [
        _createVNode("div", _hoisted_2, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.images, (image, index) => {
            return (_openBlock(), _createBlock("img", {
              key: image,
              src: image,
              class: { 'img--active': _ctx.currentSlide === index }
            }, null, 10, ["src"]))
          }), 128))
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode("button", {
            class: "carousel-space-button",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.prevSlide(true)), ["stop"]))
          }),
          _createVNode("button", {
            class: "carousel-space-button",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.nextSlide(true)), ["stop"]))
          })
        ])
      ]),
      default: _withId(() => [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("span", _hoisted_7, _toDisplayString(_ctx.splitHeadline(_ctx.$trans("main.headline")).upper), 1),
              _createVNode("span", _hoisted_8, _toDisplayString(_ctx.splitHeadline(_ctx.$trans("main.headline")).lower), 1)
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode("span", _hoisted_10, _toDisplayString(_ctx.$trans("main.text-1")), 1),
              _createVNode("span", _hoisted_11, _toDisplayString(_ctx.$trans("main.text-2")), 1)
            ]),
            _createVNode(_component_GenericButton, {
              title: _ctx.$trans('search.btn_search'),
              identifier: 'djf_update_company',
              onClick: _ctx.onClickFind
            }, null, 8, ["title", "onClick"])
          ]),
          _createVNode(_component_CarouselDots, {
            class: "carousel-dots",
            length: _ctx.images.length,
            active: _ctx.currentSlide,
            onClick: _ctx.setSlide
          }, null, 8, ["length", "active", "onClick"]),
          _createVNode("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, [
              _createVNode("span", _hoisted_14, _toDisplayString(_ctx.splitHeadline(_ctx.$trans("main.search-headline")).upper), 1),
              _createVNode("span", _hoisted_15, _toDisplayString(_ctx.splitHeadline(_ctx.$trans("main.search-headline")).lower), 1)
            ]),
            _createVNode("div", _hoisted_16, [
              _createVNode("span", _hoisted_17, _toDisplayString(_ctx.$trans("main.search-text-1")), 1),
              _createVNode("span", _hoisted_18, _toDisplayString(_ctx.$trans("main.search-text-2")), 1)
            ]),
            _createVNode(_component_GenericButton, {
              title: _ctx.$trans('search.btn_search_function'),
              identifier: 'djf_update_search',
              secondary: true,
              onClick: _ctx.onClickSearch
            }, null, 8, ["title", "onClick"])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Plane, {
      class: "hero-sub-plane",
      rounded: true
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_19, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.locations, (location, idx) => {
            return (_openBlock(), _createBlock(_Fragment, { key: location }, [
              (idx > 0)
                ? (_openBlock(), _createBlock("span", _hoisted_20, "•"))
                : _createCommentVNode("", true),
              _createVNode("span", _hoisted_21, _toDisplayString(location), 1)
            ], 64))
          }), 128))
        ])
      ]),
      _: 1
    })
  ]))
})